import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { isApiError } from '../api/apiError';

export const createApiErrorMiddleware = (report: (error: import('../api/apiError').ApiError, actionType: string) => void): Middleware =>
    () => next => action => {
        const result = next(action);
        if (isRejectedWithValue(action) && isApiError(action.payload)) report(action.payload, action.type);
        return result;
    };
